"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ShareInvalidPasscodeError;
// eslint-disable-next-line no-unused-vars
function ShareInvalidPasscodeError(code, message) {
  var instance = new Error(message);
  instance.message = message;
  instance.code = code;
  Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
  if (Error.captureStackTrace) {
    Error.captureStackTrace(instance, ShareInvalidPasscodeError);
  }
  return instance;
}
ShareInvalidPasscodeError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
});
if (Object.setPrototypeOf) {
  Object.setPrototypeOf(ShareInvalidPasscodeError, Error);
} else {
  ShareInvalidPasscodeError.__proto__ = Error;
}